/**
 * @fileoverview GET handler for the "/:app_group_id/figma/oauth/status" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appGroupIdFigmaOauthStatus } from "./constants";
import type { GetAppGroupIdFigmaOauthStatusResult } from "./types";
import { isGetAppGroupIdFigmaOauthStatusResult } from "./validators";

export const getAppGroupIdFigmaOauthStatus = reactQueryFetcherAdapter(
  appGroupIdFigmaOauthStatus,
  (signal: AbortSignal, appGroupId: string): Promise<GetAppGroupIdFigmaOauthStatusResult> => {
    return fetch(`/${appGroupId}/figma/oauth/status`, "GET", {}, { signal });
  },
  isGetAppGroupIdFigmaOauthStatusResult
);
